import React from "react";
import Navbar from "./components/navbar";
import Hero from "./components/hero";
import About from "./components/about";
import Service from "./components/service";
import Client from "./components/client";
import Contact from "./components/contact";
import Footer from "./components/footer";

function App() {
  return (
    <div>
      <Navbar/>
      <Hero/>
      <About/>
      <Service/>
      <Client/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
